<script setup lang="ts">
import { computed } from 'vue';

const props = defineProps<{
  field: any;
  rowData: any;
  settings: any;
}>();

const hasTargetKey = computed(() => {
  const { targetKey } = props.settings.render;

  return targetKey.length > 1
    ? !!props.rowData[targetKey[0]][targetKey[1]]
    : !!props.rowData[targetKey[0]];
});
const targetRef = computed(() => {
  const { href, targetKey, secondaryKey } = props.settings.render;

  if (secondaryKey) {
    const primary = props.rowData[targetKey[0]];
    const secondary = props.rowData[secondaryKey[0]];

    if (primary != null && secondary != null) return `${href}${primary}/${secondary}`;

    return null;
  }

  if (targetKey.length > 1) {
    const primary = props.rowData[targetKey[0]];
    if (primary && typeof primary === 'object' && primary[targetKey[1]] != null)
      return `${href}${primary[targetKey[1]]}`;

    return null;
  }

  if (props.rowData[targetKey[0]] != null) return `${href}${props.rowData[targetKey[0]]}`;

  return null;
});
</script>

<template>
  <RouterLink
    v-if="!field && settings?.canBeUnknown && targetRef"
    class="af-link overflow-hidden hover:underline"
    :to="targetRef"
  >
    {{ $t('common.unknown') }}
  </RouterLink>

  <span
    v-else-if="!field"
    class="flex flex-col items-start gap-0.5"
  >
    {{ settings?.composedEmptyState ? $t(settings.composedEmptyState) : '-' }}
  </span>

  <a
    v-else-if="settings.render.type === 'mail'"
    class="af-link overflow-hidden hover:underline"
    target="_blank"
    :href="'mailto:' + field"
  >
    {{ field }}
  </a>

  <p
    v-else-if="!hasTargetKey"
    class="overflow-hidden text-ellipsis"
  >
    {{ field }}
  </p>

  <RouterLink
    v-else-if="targetRef"
    class="af-link overflow-hidden text-ellipsis hover:underline"
    :to="targetRef"
  >
    {{ settings.hasName ? field.name : field }}
  </RouterLink>

  <p
    v-else
    class="overflow-hidden text-ellipsis"
  >
    {{ field || '-' }}
  </p>
</template>
